export default "__VITE_ASSET__1e9be9a6__"